module.exports = __webpack_public_path__ + "static/img/3x1s.2e11669a.png";